module.exports = __webpack_public_path__ + "img/headBg1.03cd38d2.jpg";